import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { Bell } from "@phosphor-icons/react";
import { useNotifications } from "@/lib/notifications";

function relTime(iso) {
  if (!iso) return "";
  const diff = (Date.now() - new Date(iso).getTime()) / 1000;
  if (diff < 60) return "ora";
  if (diff < 3600) return `${Math.floor(diff / 60)} min fa`;
  if (diff < 86400) return `${Math.floor(diff / 3600)} h fa`;
  const days = Math.floor(diff / 86400);
  return days === 1 ? "ieri" : `${days} g fa`;
}

/** Ultime 10 notifiche, visibile solo su mobile (sotto sm). */
export const MobileNotificationsFeed = () => {
  const { items, markRead } = useNotifications();
  const nav = useNavigate();
  const list = (items || []).slice(0, 10);

  const open = async (n) => {
    if (!n.is_read) await markRead({ ids: [n._id] });
    if (n.target_url && n.target_url.startsWith("/") && n.target_url !== "/") nav(n.target_url);
  };

  return (
    <div className="block sm:hidden mb-6" data-testid="mobile-notifications-feed">
      <div className="flex items-center gap-2 mb-2">
        <Bell size={18} className="text-purple-700" />
        <div className="font-semibold text-sm">Ultime notifiche</div>
      </div>
      <div className="rounded-xl border bg-white divide-y">
        {list.length === 0 && (
          <div className="px-4 py-4 text-sm text-muted-foreground" data-testid="mobile-notifications-empty">Nessuna notifica</div>
        )}
        {list.map((n) => (
          <button
            key={n._id}
            type="button"
            onClick={() => open(n)}
            className={`w-full text-left px-4 py-3 flex items-start gap-3 transition-colors active:bg-slate-100 ${!n.is_read ? "bg-purple-50/50" : ""}`}
            data-testid={`mobile-notif-${n._id}`}
          >
            <span className={`mt-1.5 w-2 h-2 rounded-full shrink-0 ${!n.is_read ? "bg-red-500" : "bg-transparent"}`} />
            <span className="flex-1 min-w-0">
              <span className="flex items-baseline justify-between gap-2">
                <span className={`text-sm truncate ${!n.is_read ? "font-semibold" : "font-medium"}`}>{n.title}</span>
                <span className="text-[11px] text-muted-foreground shrink-0">{relTime(n.created_at)}</span>
              </span>
              {n.body && <span className="block text-xs text-slate-600 line-clamp-2 mt-0.5">{n.body}</span>}
            </span>
          </button>
        ))}
      </div>
      <Link to="/notifications" className="inline-block mt-2 text-sm font-medium text-purple-700" data-testid="mobile-notifications-all">
        Vedi tutte →
      </Link>
    </div>
  );
};
